import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/apiClient";

const SeoContext = createContext(null);

export const SeoProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/seo").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return <SeoContext.Provider value={{ settings, setSettings }}>{children}</SeoContext.Provider>;
};

export const useSeoSettings = () => useContext(SeoContext);
